export const transform = data => {
  const { id, createdAt, updatedAt, _products, ...body } = data
  return body
}
